/* NRYC – A+ Premium : JS léger, sans dépendance, chargé en defer.
   1) révélation au défilement  2) carte de membre (inclinaison)  3) bandeau (pause)  4) carrousel accessible.
   Tout reste utilisable sans ce fichier ; mouvement réduit respecté. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* 1. Révélation */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-nryc-reveal]:not(.is-in)');
    if (!els.length) return;
    if (design || reduce.matches || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Carte : inclinaison douce (souris/stylet seulement, jamais au toucher) */
  function initTilt(root) {
    if (reduce.matches || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('[data-nryc-tilt]').forEach(function (stage) {
      if (stage.__tilt) return; stage.__tilt = true;
      var card = stage.querySelector('.nryc-card'); if (!card) return;
      var raf = 0, tx = 0, ty = 0;
      function apply() { raf = 0; card.style.setProperty('--tx', tx + 'deg'); card.style.setProperty('--ty', ty + 'deg'); }
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 9;
        ty = -((e.clientY - r.top) / r.height - 0.5) * 7;
        stage.classList.add('is-tilting');
        if (!raf) raf = requestAnimationFrame(apply);
      });
      stage.addEventListener('pointerleave', function () {
        tx = 0; ty = 0; stage.classList.remove('is-tilting');
        if (!raf) raf = requestAnimationFrame(apply);
      });
    });
  }

  /* 3. Bandeau : bouton pause/lecture */
  function initTicker(root) {
    (root || document).querySelectorAll('[data-nryc-ticker]').forEach(function (t) {
      var b = t.querySelector('[data-nryc-ticker-toggle]');
      if (!b || b.__t) return; b.__t = true;
      b.addEventListener('click', function () {
        var p = t.getAttribute('data-paused') === 'true';
        t.setAttribute('data-paused', p ? 'false' : 'true');
        b.setAttribute('aria-pressed', p ? 'false' : 'true');
        b.setAttribute('aria-label', p ? 'Mettre le bandeau en pause' : 'Relancer le bandeau');
      });
    });
  }

  /* 4. Carrousel accessible */
  function initCarousel(root) {
    (root || document).querySelectorAll('[data-nryc-carousel]').forEach(function (car) {
      if (car.__car) return; car.__car = true;
      var sc = car.querySelector('[data-nryc-scroller]');
      var section = car.closest('section') || car.parentNode;
      var nav = section.querySelector('[data-nryc-nav]');
      var dots = car.querySelector('[data-nryc-dots]');
      if (!sc) return;
      var prev = nav && nav.querySelector('[data-dir="-1"]');
      var next = nav && nav.querySelector('[data-dir="1"]');
      var pages = 1, cur = 0;

      function smooth() { return reduce.matches ? 'auto' : 'smooth'; }
      function max() { return sc.scrollWidth - sc.clientWidth; }
      function build() {
        var m = max();
        pages = m > 4 ? Math.max(1, Math.ceil(sc.scrollWidth / sc.clientWidth - 0.05)) : 1;
        var many = pages > 1;
        if (nav) nav.hidden = !many;
        if (dots) {
          dots.hidden = !many;
          dots.innerHTML = '';
          if (many) {
            for (var i = 0; i < pages; i++) {
              var d = document.createElement('button');
              d.type = 'button'; d.className = 'nryc-carousel__dot';
              d.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + pages);
              d.setAttribute('data-page', i);
              dots.appendChild(d);
            }
          }
        }
        update();
      }
      function update() {
        var m = max();
        var ratio = m > 0 ? sc.scrollLeft / m : 0;
        cur = Math.round(ratio * (pages - 1));
        if (prev) prev.disabled = sc.scrollLeft <= 2;
        if (next) next.disabled = sc.scrollLeft >= m - 2;
        if (dots) dots.querySelectorAll('.nryc-carousel__dot').forEach(function (d, i) {
          if (i === cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }
      function step(dir) {
        var slide = sc.querySelector('.nryc-slide');
        var w = slide ? slide.getBoundingClientRect().width : sc.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
        var per = Math.max(1, Math.round(sc.clientWidth / (w + gap)));
        sc.scrollBy({ left: dir * per * (w + gap), behavior: smooth() });
      }
      if (nav) nav.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-dir]'); if (!b || b.disabled) return;
        step(Number(b.getAttribute('data-dir')));
      });
      if (dots) dots.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-page]'); if (!b) return;
        var i = Number(b.getAttribute('data-page'));
        sc.scrollTo({ left: pages > 1 ? (max() * i) / (pages - 1) : 0, behavior: smooth() });
      });
      car.addEventListener('keydown', function (e) {
        if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'Home') { e.preventDefault(); sc.scrollTo({ left: 0, behavior: smooth() }); }
        else if (e.key === 'End') { e.preventDefault(); sc.scrollTo({ left: max(), behavior: smooth() }); }
      });
      var tick = 0;
      sc.addEventListener('scroll', function () { if (!tick) tick = requestAnimationFrame(function () { tick = 0; update(); }); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { build(); }).observe(sc); else window.addEventListener('resize', build);
      build();
    });
  }

  function init(root) { initReveal(root); initTilt(root); initTicker(root); initCarousel(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
